import Post from 'models/post';
import Task1 from 'models/task1';

import ColorCodedDate from './common/ColorCodedDate';

export default class ContinuousFeedbackReview {
  constructor({
    isArchived,
    managerEmployeeId,
    peerStatus,
    providerEmployeeId,
    providerType,
    questionText,
    rating,
    receiverEmployeeId,
    requesterEmployeeId,
    responseType,
    submissionStatus,
    submittedBy,
    submittedOn,
    submissionDateFormatted,
    summaryFilePath,
    templateId,
    uuid,
    visibility,
    feedbackType,
    feedbackForm,
    feedbackPost,
    goal,
    requesterEmployee,
  }) {
    this.isArchived = isArchived;
    this.managerEmployeeId = managerEmployeeId;
    this.peerStatus = peerStatus;
    this.providerEmployeeId = providerEmployeeId;
    this.providerType = providerType;
    this.questionText = questionText;
    this.rating = rating;
    this.receiverEmployeeId = receiverEmployeeId;
    this.requesterEmployeeId = requesterEmployeeId;
    this.responseType = responseType;
    this.submissionStatus = submissionStatus;
    this.submittedBy = submittedBy;
    this.submittedOn = submittedOn;
    this.submissionDateFormatted = submissionDateFormatted;
    this.summaryFilePath = summaryFilePath;
    this.templateId = templateId;
    this.uuid = uuid;
    this.visibility = visibility;
    this.feedbackType = feedbackType;
    this.feedbackForm = feedbackForm;
    this.feedbackPost = feedbackPost;
    this.goal = goal;
    this.requesterEmployee = requesterEmployee;
  }

  static fromJSON({
    isArchived,
    managerEmployeeId,
    peerStatus,
    providerEmployeeId,
    providerType,
    questionText,
    rating,
    receiverEmployeeId,
    requesterEmployeeId,
    responseType,
    submissionStatus,
    submittedBy,
    submittedOn,
    submissionDateFormatted,
    summaryFilePath,
    templateId,
    uuid,
    visibility,
    feedbackType,
    feedbackForm,
    feedbackPost,
    goal,
    requesterEmployee,
  }) {
    return new ContinuousFeedbackReview({
      isArchived,
      managerEmployeeId,
      peerStatus,
      providerEmployeeId,
      providerType,
      questionText,
      rating,
      receiverEmployeeId,
      requesterEmployeeId,
      responseType,
      submissionStatus,
      submittedBy,
      submittedOn,
      submissionDateFormatted: submissionDateFormatted ? ColorCodedDate.fromJSON(submissionDateFormatted) : null,
      summaryFilePath,
      templateId,
      uuid,
      visibility,
      feedbackType,
      feedbackForm,
      feedbackPost: feedbackPost ? Post.fromJSON(feedbackPost) : null,
      goal: goal ? Task1.fromJSON(goal) : null,
      requesterEmployee,
    });
  }
}
